import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuxiliaresModule } from '../../../auxiliares/auxiliares.module';
import { GastosComponent } from './gastos.component';
import { GastosRoutingModule } from './routing';
import { DetalleClientesResumenComponent } from './detalle-clientes-resumen/detalle-clientes-resumen.component';

@NgModule({
  declarations: [GastosComponent],
  imports: [
    CommonModule,
    AuxiliaresModule,
    GastosRoutingModule,
    DetalleClientesResumenComponent,
  ],
  exports: [GastosComponent],
})
export class GastosModule {}
